import { styled } from "@mui/material/styles";

const Root = styled("span")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  flexShrink: 0,
  height: 16,
  padding: theme.spacing(0, 1.5),
  borderRadius: 999,
  fontSize: 10,
  fontWeight: 700,
  lineHeight: 1,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  color: theme.palette.secondary[9],
  backgroundColor: theme.palette.primary.light,
}));

/** Compact "New" marker for a freshly launched entry point, on the dark UI. */
export const NewBadge = () => <Root>New</Root>;
